"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraPage = exports.EuraPageRow = exports.EuraPageRowBlocks = exports.EuraPageRowBlock = void 0;
const react_1 = __importStar(require("react"));
require("../styles/eura-page.css");
/**
 * Tarkoitettu käytettäväksi EuraPageRow-komponentin childreninä.
 * @param props
 * @param props.position Tämän kyseisen rivilohkon sijainti. Joko "top", "middle" tai "bottom". Vaikuttaa tyylittelyn ulkonäköön eli lisätäänkö katkoviiva sisällön loppuun yms.
 * Esimerkkiä: https://app.zeplin.io/project/5e85d3acc970c02147d45001/screen/5f414485497e452b5b685e1e
 * @param props.children Sisältö
 */
const EuraPageRowBlock = (props) => {
    const position = props.position || 'generic';
    const blockClass = [props.className || '', `eura-page-row__block-${position}`].join(' ').trim();
    let SpanDecoration;
    (function (SpanDecoration) {
        SpanDecoration["top"] = "eura-page-row__block-decoration";
        SpanDecoration["middle"] = "eura-page-row__block-decoration";
        SpanDecoration["generic"] = "";
        SpanDecoration["bottom"] = "";
    })(SpanDecoration || (SpanDecoration = {}));
    let BlockPadding;
    (function (BlockPadding) {
        BlockPadding["generic"] = "eura-page-row__block-padding";
        BlockPadding["top"] = "eura-page-row__block-padding";
        BlockPadding["middle"] = "eura-page-row__block-padding-middle";
        BlockPadding["bottom"] = "";
    })(BlockPadding || (BlockPadding = {}));
    return (react_1.default.createElement("div", { className: blockClass },
        react_1.default.createElement("span", { className: SpanDecoration[position] },
            react_1.default.createElement("div", { className: `eura-page-row__block ${BlockPadding[position]}`.trim() }, props.children))));
};
exports.EuraPageRowBlock = EuraPageRowBlock;
/**
 * Komponentti, jonka sisään voi laittaa 1-N kappaletta EuraPageRowBlock -elementtejä ja
 * niille laitetaan 'position'-attribuutti automaattisesti oikein.
 *
 * Tyhjät placeholderit (null ja false) eivät haittaa.
 *
 * Esim.
      <EuraPageRowBlocks>
        {isEkaEnabled && (
          <EuraPageRowBlock>
            <Eka />
          </EuraPageRowBlock>
        )}
        <EuraPageRowBlock>
          <Toka />
        </EuraPageRowBlock>
      </EuraPageRowBlocks>
 *
 */
const EuraPageRowBlocks = ({ children }) => {
    var _a, _b;
    const count = (_b = (_a = react_1.default.Children.map(children, (item) => !(!item || item.type.name !== exports.EuraPageRowBlock.name))) === null || _a === void 0 ? void 0 : _a.filter((x) => x).length) !== null && _b !== void 0 ? _b : 0;
    let index = 0;
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.Children.map(children, (item) => {
        var _a;
        if (!item || item.type.name !== exports.EuraPageRowBlock.name)
            return item;
        const [, position] = (_a = [
            [count === 1, undefined],
            [index === 0, 'top'],
            [index === count - 1, 'bottom'],
            [true, 'middle'],
        ].find(([pred]) => pred)) !== null && _a !== void 0 ? _a : []; // '?? []' vain kääntäjälle, listasta löytyy aina vastine
        index++;
        return react_1.default.cloneElement(item, { position: position }, item.props.children);
    })));
};
exports.EuraPageRowBlocks = EuraPageRowBlocks;
/**
 * Tarkoitettu käytettäväksi EuraPage-komponentin sisällön riveinä.
 * https://app.zeplin.io/project/5e85d3acc970c02147d45001/screen/5f414485497e452b5b685e1e. Esitelty valkoinen paperiliuska on tämä komponentti.
 * @param props.children EuraPageRowBlock-komponentteja.
 * @param props.title Rivin otsikko.
 */
const EuraPageRow = (props) => {
    const id = props.title ? props.title.split(' ').join('') + 'PageRowId' : undefined;
    const ariaObject = id ? { 'aria-labelledby': id } : { 'aria-label': props.ariaLabel };
    return (react_1.default.createElement("div", Object.assign({ role: props.role || 'region' }, ariaObject, { className: 'eura-page-row ' + props.className || '' }),
        react_1.default.createElement("div", { id: id, className: props.title ? undefined : 'eura-page-row-header' }, props.title && (react_1.default.createElement("h2", { className: 'eura-page-row-header' }, props.title))),
        props.children));
};
exports.EuraPageRow = EuraPageRow;
/**
 * Euran form-sivun sisällön pohja.
 * @param props
 * @param props.children Parhaan tuloksen saavuttamiseksi wrappaa childrenit EuraPageRow-komponenttien sisään.
 * @param props.title Lomakesivun otsikko
 */
const EuraPage = (props) => {
    var _a;
    const ref = (0, react_1.useRef)(null);
    const ariaId = 'pageTitleId';
    (0, react_1.useEffect)(() => {
        if (ref.current !== null) {
            ref.current.focus();
        }
    }, [props.title]);
    return (react_1.default.createElement("div", { className: (_a = props.className) !== null && _a !== void 0 ? _a : '', "aria-labelledby": ariaId },
        react_1.default.createElement("h1", { id: ariaId, tabIndex: 0, ref: ref, className: 'eura-page-title' }, props.title),
        props.children));
};
exports.EuraPage = EuraPage;
